import { z } from "zod";

export const skillStatusValues = ["draft", "active", "archived"] as const;
export type SkillStatus = (typeof skillStatusValues)[number];

// Field set WITHOUT the status default — the base for both variants. zod's
// .partial() still applies .default() values for absent keys, so a defaulted
// update schema would re-inject status:"draft" into every partial edit. The
// default lives only on create.
const skillFieldsSchema = z.object({
  name: z.string().min(1, "Name is required").max(120),
  description: z.string().max(2000).nullable().optional(),
  /**
   * The categories this skill is in — the whole set, replacing whatever it
   * was. Absent means "leave membership alone", which is what every caller
   * that predates the category/theme merge sends.
   */
  categoryIds: z.array(z.string().uuid()).optional(),
  status: z.enum(skillStatusValues),
});
export const skillCreateSchema = skillFieldsSchema.extend({
  status: z.enum(skillStatusValues).default("draft"),
});
export const skillUpdateSchema = skillFieldsSchema.partial();
export type SkillCreateInput = z.infer<typeof skillCreateSchema>;
export type SkillUpdateInput = z.infer<typeof skillUpdateSchema>;
